import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
})
export class AboutComponent implements OnInit, OnDestroy {  
  language!: string;
  components: any[] = [];
  mainData: any;
  aboutusComponents: any[] = [];
  routeSub!: Subscription;   
  isTeamPage: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private metaTagService:MetaTagService
  ) {}

  ngOnInit() {        
    this.language = this.route.snapshot.url[0].path
    
    this.routeSub = this.route.params.subscribe(params => {
      if (params['lang']) {
        this.language = params['lang'];
        this.getResolverData();        
      }
    });               
    this.getResolverData();        
  }

  getResolverData(){
    const resolverData = this.route.snapshot.data['aboutData'];        
    if (resolverData) {      
      this.isTeamPage = this.route.snapshot.url.some(segment => segment.path === 'team');
      this.aboutusComponents = resolverData.aboutusComponents;      
      this.metaTagService.updateMetaTags(resolverData.metadata.meta);
    } else {
      console.error("Resolver data is undefined");
    }
  }  

  ngOnDestroy(): void {   
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}

